module.exports = __webpack_public_path__ + "static/NW_KP_Bild_Lands_1_b-4ad39bb12f618428c81876ed7729098a.jpg";